/*
 * File: GetUser.ts
 * Author: Austin Robinson
 * Date Created: 7/30/2023
 * Copyright (c) DrivingDoc 2023
 */
import { createQuery } from 'react-query-kit';

import { privateApi } from 'api';

export type GetUserParams = {
  id: string;
};

export type User = {
  tenant_id: string;
  id: string;
  title: string | null;
  first_name: string | null;
  middle_name: string | null;
  last_name: string | null;
  nickname: string | null;
  email: string | null;
  date_of_birth: string | null;
  sex: string | null;
  active: boolean;
  created_at: string | null;
  updated_at: string | null;
  created_by: string | null;
  updated_by: string | null;
  username: string | null;
  user_addresses: {
    tenant_id: string;
    user_id: string;
    priority: number;
    name: string | null;
    street_address: string | null;
    apt_no: string | null;
    po_box_no: string | null;
    city: string | null;
    state: string | null;
    zip: string | null;
    country: string | null;
  }[];
  user_phones: {
    tenant_id: string;
    user_id: string;
    priority: number;
    name: string | null;
    type: string | null;
    phone: string | null;
    extension: string | null;
  }[];
};

async function getUser(params: GetUserParams) {
  if (!params.id) {
    return null;
  }
  // make api call
  const result = await privateApi.get(`${import.meta.env.VITE_API_BASE_URL}/users/${params.id}`, {});

  // console.log(result.data);
  // return the data object
  return result.data as User;
}

const useGetUser = createQuery<User | null, GetUserParams, Error>({
  queryKey: ['user'],
  fetcher: (variables) => getUser(variables),
  // if u only wanna fetch once
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  enabled: (data) => !data,
});

export { getUser, useGetUser };
